module.exports = __webpack_public_path__ + "static/media/empty.e444f618.png";